import React, { useEffect, useRef } from "react"
// @ts-ignore
import {
  Route,
  Switch,
  Redirect,
  useHistory,
  useLocation,
} from "react-router-dom"
import Landing from "./pages/landing"
import Compilation from "./pages/compilation"
import Reports from "./pages/reports"
import CustomAlert from "./components/ui-components/custom-alert"
import { useAlertStore } from "./utils/alert-store"
import useStore from "./utils/store" // Add this import
import consts from "./utils/consts.json"
import MyReviews from "./pages/my-reviews"

function V2Routes() {
  const { alert, closeAlert } = useAlertStore()
  const history = useHistory()
  const location = useLocation()
  const didCheckRef = useRef(false)
  const isSimulationDetailView = useStore((state) => state.isSimulationDetailView) // Add this line

  // Show native dialog on refresh/close for /v2/compilation
  useEffect(() => {
    if (location.pathname === consts.ROUTES.COMPILATION) {
      const handler = (e) => {
        e.preventDefault()
        e.returnValue =
          "All progress will be lost if you leave or refresh this page."
        return e.returnValue
      }
      window.addEventListener("beforeunload", handler)
      return () => window.removeEventListener("beforeunload", handler)
    }
  }, [location.pathname])

  // Remove review_id from URL when going back to simulations list view
  useEffect(() => {
    if (!isSimulationDetailView) {
      const url = new URL(window.location);
      if (url.searchParams.has('review_id')) {
        url.searchParams.delete('review_id');
        window.history.pushState({}, '', url);
      }
    }
  }, [isSimulationDetailView]);

  // On actual reload, redirect to landing page
  useEffect(() => {
    if (didCheckRef.current) return
    didCheckRef.current = true

    const navEntries = performance.getEntriesByType("navigation")
    const isReload = navEntries.length > 0 && navEntries[0].type === "reload"

    if (window.location.pathname === consts.ROUTES.COMPILATION && isReload) {
      history.replace(consts.ROUTES.LANDING)
    }
  }, [history])

  return (
    <>
      <CustomAlert
        open={alert.open}
        severity={alert.severity}
        title={alert.title}
        message={alert.message}
        onClose={closeAlert}
        autoHideDuration={4000}
      />
      <Switch>
        <Route
          exact
          path={consts.ROUTES.ROOT}
          render={() => <Redirect to={consts.ROUTES.LANDING} />}
        />
        <Route path={consts.ROUTES.LANDING} component={Landing} />
        <Route path={consts.ROUTES.COMPILATION} component={Compilation} />
        <Route
          path={`${consts.ROUTES.REPORTS}/:reviewId`}
          component={Reports}
        />
        <Route path={consts.ROUTES.MYREVIEWS} component={MyReviews} />
        {/* Add more subroutes here as needed */}
      </Switch>
    </>
  )
}

export default V2Routes
